import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { sendLocationToGtag } from "../../funcs/sendLocationToGtag";

export function useSendLocationToGtag(pageTitle: string = "") {

    const location = useLocation();
    useEffect(() => {
        sendLocationToGtag(location.pathname, pageTitle);
    }, [location.pathname, pageTitle]);
}